"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.API_PROD_LIST_INVEN_STORES = exports.API_PROD_UPDATE_VARIANTS_INVEN = exports.API_PROD_LIST_INVEN_VARIANTS = exports.API_PROD_UPDATE_XMD_PRCD_LIST = exports.API_PROD_FETCH_OPT_IMAGES = exports.API_PROD_UPDATE_DESCRIPTION = exports.API_PROD_FETCH_DESCRIPTION = exports.API_PROD_SAVE_OPT_IMAGES = exports.API_PROD_FETCH = exports.API_PROD_LIST = void 0;
var API_PROD_LIST;
(function (API_PROD_LIST) {
    API_PROD_LIST.PATH = '/prod/list';
    API_PROD_LIST.PURPOSE = '카페24 상품 목록조회';
})(API_PROD_LIST = exports.API_PROD_LIST || (exports.API_PROD_LIST = {}));
var API_PROD_FETCH;
(function (API_PROD_FETCH) {
    API_PROD_FETCH.PATH = '/prod/fetch';
    API_PROD_FETCH.PURPOSE = '카페24 상품 정보조회';
})(API_PROD_FETCH = exports.API_PROD_FETCH || (exports.API_PROD_FETCH = {}));
var API_PROD_SAVE_OPT_IMAGES;
(function (API_PROD_SAVE_OPT_IMAGES) {
    API_PROD_SAVE_OPT_IMAGES.PATH = '/prod/save-opt-images';
    API_PROD_SAVE_OPT_IMAGES.PURPOSE = '상품 옵션별 이미지 정보 저장';
})(API_PROD_SAVE_OPT_IMAGES = exports.API_PROD_SAVE_OPT_IMAGES || (exports.API_PROD_SAVE_OPT_IMAGES = {}));
var API_PROD_FETCH_DESCRIPTION;
(function (API_PROD_FETCH_DESCRIPTION) {
    API_PROD_FETCH_DESCRIPTION.PATH = '/prod/fetch-description';
    API_PROD_FETCH_DESCRIPTION.PURPOSE = '카페24 상품 상세정보 블록 조회';
})(API_PROD_FETCH_DESCRIPTION = exports.API_PROD_FETCH_DESCRIPTION || (exports.API_PROD_FETCH_DESCRIPTION = {}));
var API_PROD_UPDATE_DESCRIPTION;
(function (API_PROD_UPDATE_DESCRIPTION) {
    API_PROD_UPDATE_DESCRIPTION.PATH = '/prod/update-description';
    API_PROD_UPDATE_DESCRIPTION.PURPOSE = '상품 상세설명 업데이트';
    ;
})(API_PROD_UPDATE_DESCRIPTION = exports.API_PROD_UPDATE_DESCRIPTION || (exports.API_PROD_UPDATE_DESCRIPTION = {}));
var API_PROD_FETCH_OPT_IMAGES;
(function (API_PROD_FETCH_OPT_IMAGES) {
    API_PROD_FETCH_OPT_IMAGES.PATH = '/prod/fetch-opt-images';
    API_PROD_FETCH_OPT_IMAGES.PURPOSE = '상품 옵션별 이미지 정보 조회';
})(API_PROD_FETCH_OPT_IMAGES = exports.API_PROD_FETCH_OPT_IMAGES || (exports.API_PROD_FETCH_OPT_IMAGES = {}));
var API_PROD_UPDATE_XMD_PRCD_LIST;
(function (API_PROD_UPDATE_XMD_PRCD_LIST) {
    API_PROD_UPDATE_XMD_PRCD_LIST.PATH = '/prod/update-xmd-prcd-list';
    API_PROD_UPDATE_XMD_PRCD_LIST.PURPOSE = '상품의 XMD 재고연동 상품코드 업데이트';
})(API_PROD_UPDATE_XMD_PRCD_LIST = exports.API_PROD_UPDATE_XMD_PRCD_LIST || (exports.API_PROD_UPDATE_XMD_PRCD_LIST = {}));
var API_PROD_LIST_INVEN_VARIANTS;
(function (API_PROD_LIST_INVEN_VARIANTS) {
    API_PROD_LIST_INVEN_VARIANTS.PATH = '/prod/list-inven-variants';
    API_PROD_LIST_INVEN_VARIANTS.PURPOSE = '상품의 품목별 재고 조회';
})(API_PROD_LIST_INVEN_VARIANTS = exports.API_PROD_LIST_INVEN_VARIANTS || (exports.API_PROD_LIST_INVEN_VARIANTS = {}));
var API_PROD_UPDATE_VARIANTS_INVEN;
(function (API_PROD_UPDATE_VARIANTS_INVEN) {
    API_PROD_UPDATE_VARIANTS_INVEN.PATH = '/prod/update-variants-inven';
    API_PROD_UPDATE_VARIANTS_INVEN.PURPOSE = '상품의 품목별 재고 업데이트 실행';
})(API_PROD_UPDATE_VARIANTS_INVEN = exports.API_PROD_UPDATE_VARIANTS_INVEN || (exports.API_PROD_UPDATE_VARIANTS_INVEN = {}));
var API_PROD_LIST_INVEN_STORES;
(function (API_PROD_LIST_INVEN_STORES) {
    API_PROD_LIST_INVEN_STORES.PATH = '/prod/list-inven-stores';
    API_PROD_LIST_INVEN_STORES.PURPOSE = '재고보유 매장 조회';
})(API_PROD_LIST_INVEN_STORES = exports.API_PROD_LIST_INVEN_STORES || (exports.API_PROD_LIST_INVEN_STORES = {}));
//# sourceMappingURL=api-prod.js.map